import { generateToken, TOKEN_HEADER } from '../utils/tokenUtils';
import React, { useState, useEffect } from 'react';
import { trackPageView } from '../utils/analytics';
import '../styles/benefits.css';
import '../styles/PopupForm.css';
import SEO from '../components/SEO';
import '../styles/learning-experience.css';
import '../styles/pricing.css';
import '../styles/faq.css';
import '../styles/cta-final.css';
import '../styles/curriculum.css';
import '../styles/pillars.css';
import '../styles/career-path.css';
import '../styles/mentor.css';
import '../styles/testimonials.css';
import programsData from '../data/programs.json';
import PopupForm from '../components/PopupForm';
import { API_ENDPOINTS } from '../config/constants';

// TopBarLeadForm component (reused from CopilotTraining.js)
function TopBarLeadForm({ visible, onSubmit, onClose, submitting }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [mobile, setMobile] = useState('');
  const [consent, setConsent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name.trim() || !email.trim() || !mobile.trim() || !consent) {
      setError('Please fill all fields and accept the consent.');
      return;
    }
    setError('');
    onSubmit({ name, email, mobile, consent });
  };

  if (!visible) return null;
  return (
    <div className="topbar-lead-form">
      <div className="topbar-lead-form-cta">Register for our upcoming Workshop</div>
      <form onSubmit={handleSubmit} className="topbar-lead-form-inner">
        <input
          type="text"
          placeholder="Name"
          value={name}
          onChange={e => setName(e.target.value)}
          disabled={submitting}
          required
        />
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          disabled={submitting}
          required
        />
        <input
          type="tel"
          placeholder="Mobile"
          value={mobile}
          onChange={e => setMobile(e.target.value)}
          disabled={submitting}
          required
          pattern="[0-9]{10,15}"
        />
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '0.85rem' }}>
          <input
            type="checkbox"
            id="topbar-consent-arch"
            checked={consent}
            onChange={e => setConsent(e.target.checked)}
            disabled={submitting}
            required
          />
          <label htmlFor="topbar-consent-arch" style={{ cursor: 'pointer' }}>I allow to send me regular updates</label>
        </div>
        <button type="submit" disabled={submitting}>
          {submitting ? 'Submitting...' : 'Get Info'}
        </button>
        <button type="button" className="topbar-lead-form-close" onClick={onClose} aria-label="Close">×</button>
      </form>
      {error && <div className="topbar-lead-form-error">{error}</div>}
    </div>
  );
}
 

function ArchitectProgram() {
  // ...existing state declarations...
  const [showTopBarForm, setShowTopBarForm] = useState(false);


  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY || document.documentElement.scrollTop;
      const pageHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (pageHeight > 0 && scrolled > pageHeight * 0.10) {
        if (window.innerWidth <= 900) {
          setShowTopBarForm(true);
        }
      } else {
        setShowTopBarForm(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleTopBarFormSubmit = async ({ name, email, mobile, consent }) => {
    setTopBarSubmitting(true);
    try {
      let token = localStorage.getItem('token');
      if (!token) {
        token = generateToken();
        localStorage.setItem('token', token);
      }
      const headers = {
        'Content-Type': 'application/json',
        [TOKEN_HEADER]: token
      };
      const response = await fetch(API_ENDPOINTS.LEADS_SUBMIT, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          name,
          email,
          mobile,
          consent,
          source: 'architect_topbar',
          interestedIn: 'architect_program'
        })
      });
      if (!response.ok) throw new Error('Failed to submit');
      setTopBarSubmitted(true);
      setTimeout(() => {
        setShowTopBarForm(false);
        setTopBarSubmitted(false);
      }, 2500);
    } catch (e) {
      alert('Failed to submit. Please try again.');
    } finally {
    setTopBarSubmitting(false);
  }
};

// Top bar lead form state for ArchitectProgram.js
  const [topBarSubmitting, setTopBarSubmitting] = useState(false);
  const [topBarSubmitted, setTopBarSubmitted] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [formType, setFormType] = useState('');
  const [confirmationModal, setConfirmationModal] = useState({
    isOpen: false,
    message: '',
    title: ''
  });
  const [showChaiChat, setShowChaiChat] = useState(false);
  const [chaiMessages, setChaiMessages] = useState([]);
  const [chaiInput, setChaiInput] = useState('');
  const [chaiStep, setChaiStep] = useState('initial'); // initial -> pricing_shared -> collecting_name -> collecting_email -> collecting_mobile -> completed
  const [chaiLeadData, setChaiLeadData] = useState({ name: '', email: '', mobile: '' });
  const architectChatPrompts = [
    { label: 'Fees & seats', value: 'What is the current fee and seat limit?' },
    { label: 'Schedule a call', value: 'Help me schedule a mentor call.' },
    { label: 'Curriculum', value: 'Share the curriculum outline.' },
    { label: 'Cohort format', value: 'How does the 4-week cohort run?' }
  ];
  const [visibleSteps, setVisibleSteps] = useState([]);
  const [visibleWhoCards, setVisibleWhoCards] = useState([]);
  const [visibleToolCards, setVisibleToolCards] = useState([]);
  const [visibleModules, setVisibleModules] = useState([]);
  const [showPillarsSidebar, setShowPillarsSidebar] = useState(false);
  const [showToolsSidebar, setShowToolsSidebar] = useState(false);
  const [showSparksSidebar, setShowSparksSidebar] = useState(false);
  const [isMobileOrTablet, setIsMobileOrTablet] = useState(false);
  const [userLocation, setUserLocation] = useState('IN');
    const itinerary = require('../data/itinerary.json');
    const testimonials = require('../data/testimonials.json').filter(t => t.program === 'architect');
  
  // Get architect program data
  const architectProgram = programsData.architectProgram;

  // Get location-based pricing
  const getLocationPricing = () => {
    if (architectProgram.pricing && architectProgram.pricing.locations && architectProgram.pricing.locations[userLocation]) {
      return architectProgram.pricing.locations[userLocation];
    }
    // Default to IN pricing
    return { current: '₹24,999', original: '₹42,999' };
  };

  const pricing = getLocationPricing();

  useEffect(() => {
    window.scrollTo(0, 0);
    
    // Get location from sessionStorage
    const storedLocation = sessionStorage.getItem('loc');
    if (storedLocation) {
      setUserLocation(storedLocation);
    }
  }, []);

  useEffect(() => {
    setShowChaiChat(true);
  }, []);

  // Seed Ask Chai conversation with architect program context
  useEffect(() => {
    setChaiMessages((prev) => {
      if (prev.length > 0) return prev;
      return [
        {
          type: 'bot',
          text: `Hi! I'm Chai. 👋 Want the fee and seats? I can share that, then help you schedule or get the curriculum.`,
          timestamp: new Date().toISOString()
        }
      ];
    });
  }, [pricing.current, pricing.original]);

  // Detect mobile/tablet screen size
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobileOrTablet(window.innerWidth <= 1024);
    };
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const openPopup = (type) => {
    setFormType(type);
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };

  const showConfirmation = (type) => {
    const messages = {
      schedule_call: {
        title: "Call Request Received!",
        message: "Thanks for your interest. Our mentor will get in touch with you shortly to schedule the call."
      },
      curriculum: {
        title: "Curriculum Sent!",
        message: "The architect program curriculum has been sent to your email. Check your inbox shortly."
      },
      mentor_connect: {
        title: "Request Received!",
        message: "Thanks for your interest in connecting with our mentor. We'll get back to you soon."
      }
    };
    
    setConfirmationModal({
      isOpen: true,
      title: messages[type].title,
      message: messages[type].message
    });

    // Auto close after 3 seconds
    setTimeout(() => {
      setConfirmationModal(prev => ({ ...prev, isOpen: false }));
    }, 3000);
  };

  const closeConfirmation = () => {
    setConfirmationModal(prev => ({ ...prev, isOpen: false }));
  };

  const handleChaiResponse = async (rawInput) => {
    const input = rawInput.toLowerCase();

    if (chaiStep === 'initial') {
      setChaiStep('pricing_shared');
      setChaiMessages(prev => [...prev, {
        type: 'bot',
        text: `The Aspiring Architect Program is ${pricing.current} (was ${pricing.original}). Only 30 seats per cohort.\n\nWant me to reserve your spot? What's your name?`,
        timestamp: new Date().toISOString()
      }]);
      return;
    }

    if (chaiStep === 'pricing_shared') {
      setChaiLeadData(prev => ({ ...prev, name: rawInput.trim() }));
      setChaiStep('collecting_email');
      setChaiMessages(prev => [...prev, {
        type: 'bot',
        text: `Nice to meet you, ${rawInput.trim()}! What's the best email to send the cohort details and call link?`,
        timestamp: new Date().toISOString()
      }]);
      return;
    }

    if (chaiStep === 'collecting_email') {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(rawInput.trim())) {
        setChaiMessages(prev => [...prev, {
          type: 'bot',
          text: 'That email looks off. Please share a valid email (e.g., name@example.com).',
          timestamp: new Date().toISOString()
        }]);
        return;
      }
      setChaiLeadData(prev => ({ ...prev, email: rawInput.trim() }));
      setChaiStep('collecting_mobile');
      setChaiMessages(prev => [...prev, {
        type: 'bot',
        text: 'Thanks! Finally, what is your mobile number?',
        timestamp: new Date().toISOString()
      }]);
      return;
    }

    if (chaiStep === 'collecting_mobile') {
      const mobile = rawInput.trim();
      setChaiLeadData(prev => ({ ...prev, mobile }));
      setChaiStep('submitting');

      setChaiMessages(prev => [...prev, {
        type: 'bot',
        text: 'Saving your details... ⏳',
        timestamp: new Date().toISOString()
      }]);

      try {
        let token = localStorage.getItem('token');
        if (!token) {
          token = generateToken();
          localStorage.setItem('token', token);
        }
        const headers = {
          'Content-Type': 'application/json',
          [TOKEN_HEADER]: token
        };
        const body = {
          name: chaiLeadData.name,
          email: chaiLeadData.email,
          mobile,
          consent: true,
          source: 'architect_chai_chat',
          interestedIn: 'architect_program'
        };
        const response = await fetch(API_ENDPOINTS.LEADS_SUBMIT, {
          method: 'POST',
          headers,
          body: JSON.stringify(body)
        });
        if (!response.ok) throw new Error('Lead save failed');
        setChaiStep('completed');
        setChaiMessages(prev => [...prev, {
          type: 'bot',
          text: `Done! You're queued for the next cohort at ${pricing.current}. Want me to open the mentor call or curriculum form now?`,
          timestamp: new Date().toISOString()
        }]);
      } catch (err) {
        console.error('Chai lead submit error:', err);
        setChaiStep('pricing_shared');
        setChaiMessages(prev => [...prev, {
          type: 'bot',
          text: 'Could not save that. Can we retry? Tell me your name again.',
          timestamp: new Date().toISOString()
        }]);
      }
      return;
    }

    let response = "I can open the mentor call form or send the curriculum. Which would you like?";
    if (input.includes('call') || input.includes('mentor') || input.includes('schedule')) {
      response = 'Opening the mentor call form for you.';
      setTimeout(() => openPopup('schedule_call'), 120);
    } else if (input.includes('curriculum') || input.includes('outline')) {
      response = 'Opening the curriculum request form.';
      setTimeout(() => openPopup('curriculum'), 120);
    }
    setChaiMessages(prev => [...prev, { type: 'bot', text: response, timestamp: new Date().toISOString() }]);
  };

  const handleChaiQuickPrompt = (prompt) => {
    setChaiMessages(prev => [...prev, { type: 'user', text: prompt, timestamp: new Date().toISOString() }]);
    handleChaiResponse(prompt);
  };

  const handleChaiSubmit = (e) => {
    e.preventDefault();
    if (!chaiInput.trim()) return;
    const trimmed = chaiInput.trim();
    setChaiMessages(prev => [...prev, { type: 'user', text: trimmed, timestamp: new Date().toISOString() }]);
    setChaiInput('');
    handleChaiResponse(trimmed);
  };
  
  useEffect(() => {
    trackPageView('Architect Program', 'Program Details');
  }, []);

  // Intersection Observer for step animations
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = parseInt(entry.target.dataset.index);
            setVisibleSteps((prev) => [...new Set([...prev, index])]);
          }
        });
      },
      { threshold: 0.2 }
    );

    const stepElements = document.querySelectorAll('.pillar-step-item');
    stepElements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  // Intersection Observer for "Who Is This For" cards animation
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = parseInt(entry.target.dataset.cardindex);
            setVisibleWhoCards((prev) => [...new Set([...prev, index])]);
          }
        });
      },
      { threshold: 0.2 }
    );

    const cardElements = document.querySelectorAll('.who-card-item');
    cardElements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  // Intersection Observer for "Tools You Will Master" animation
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = parseInt(entry.target.dataset.toolindex);
            setVisibleToolCards((prev) => [...new Set([...prev, index])]);
          }
        });
      },
      { threshold: 0.2 }
    );

    const toolElements = document.querySelectorAll('.tool-card-item');
    toolElements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  // Intersection Observer for module cards animation
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = parseInt(entry.target.dataset.moduleindex);
            setVisibleModules((prev) => [...new Set([...prev, index])]);
          }
        });
      },
      { threshold: 0.2 }
    );

    const moduleElements = document.querySelectorAll('.module-card-item');
    moduleElements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  // Intersection Observer for 5 Pillars sidebar
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          setShowPillarsSidebar(entry.isIntersecting);
        });
      },
      { threshold: 0.1 }
    );

    const pillarsSection = document.querySelector('.pillars-section');
    if (pillarsSection) {
      observer.observe(pillarsSection);
    }

    return () => observer.disconnect();
  }, []);

  // Intersection Observer for Tools section sidebar
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          setShowToolsSidebar(entry.isIntersecting);
        });
      },
      { threshold: 0.1 }
    );

    const toolsSection = document.querySelector('.tools-section');
    if (toolsSection) {
      observer.observe(toolsSection);
    }

    return () => observer.disconnect();
  }, []);

  // Intersection Observer for SPARKS section sidebar
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          setShowSparksSidebar(entry.isIntersecting);
        });
      },
      { threshold: 0.1 }
    );

    const sparksSection = document.querySelector('.itinerary-section');
    if (sparksSection) {
      observer.observe(sparksSection);
    }

    return () => observer.disconnect();
  }, []);

  const data = programsData.architectProgram;
 
  return (
    <div className="architect-page">
      {/* Mobile Top Bar Lead Form for ArchitectProgram.js */}
      <TopBarLeadForm
        visible={showTopBarForm && !topBarSubmitted}
        onSubmit={handleTopBarFormSubmit}
        onClose={() => setShowTopBarForm(false)}
        submitting={topBarSubmitting}
      />
      {topBarSubmitted && showTopBarForm && (
        <div className="topbar-lead-form-success">Thank you! We'll be in touch soon.</div>
      )}
      
      {/* Slider Window for Pillars, Tools, and SPARKS */}
      {(showPillarsSidebar || showToolsSidebar || showSparksSidebar) && (
        <div style={{
          position: 'fixed',
          ...(isMobileOrTablet ? {
            left: '50%',
            top: 0,
            transform: (showPillarsSidebar || showToolsSidebar || showSparksSidebar) ? 'translateX(-50%) translateY(0)' : 'translateX(-50%) translateY(-100%)',
            borderRadius: '0 0 12px 12px',
            maxWidth: '90%',
            width: '100%',
            boxShadow: '0 2px 12px rgba(218, 41, 28, 0.3)',
            padding: '16px 20px'
          } : {
            left: 0,
            top: '50%',
            transform: (showPillarsSidebar || showToolsSidebar || showSparksSidebar) ? 'translateY(-50%) translateX(0)' : 'translateY(-50%) translateX(-100%)',
            borderRadius: '0 12px 12px 0',
            maxWidth: '220px',
            boxShadow: '2px 0 12px rgba(218, 41, 28, 0.3)',
            padding: '20px 24px'
          }),
          background: 'linear-gradient(135deg, #DA291C, #ff6b6b)',
          zIndex: 1000,
          transition: 'transform 0.4s ease-out'
        }}>
          <div style={{
            color: '#fff',
            fontSize: isMobileOrTablet ? '1rem' : '1.1rem',
            fontWeight: 700,
            marginBottom: isMobileOrTablet ? '10px' : '14px',
            lineHeight: '1.3',
            textAlign: isMobileOrTablet ? 'center' : 'left'
          }}>
            {showSparksSidebar ? 'Discover the power of our proprietary framework' : showToolsSidebar ? 'Tell me more tools I can master' : 'Know more about 5 Pillars'}
          </div>
          <button
            onClick={() => { gtag_report_conversion(); openPopup('curriculum'); }}
            style={{
              background: '#fff',
              color: '#DA291C',
              border: 'none',
              padding: '10px 20px',
              borderRadius: '8px',
              fontSize: '0.95rem',
              fontWeight: 700,
              cursor: 'pointer',
              width: '100%',
              transition: 'transform 0.2s, box-shadow 0.2s',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.2)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
            }}
          >
            Get Details
          </button>
        </div>
      )}
      
      <SEO pageName="architectProgram" />
      <section className="hero-section architect-hero" style={{ position: 'relative', backgroundImage: 'url(/images/background.jpg)', backgroundSize: 'cover', backgroundPosition: 'center', width: '100%' }}>
        <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.8)', zIndex: 1 }}></div>
        <div className="hero-content" style={{ display: 'flex', alignItems: 'center', gap: '2.5rem', position: 'relative', zIndex: 2 }}>
          <div className="hero-text" style={{ flex: 1 }}>
            <h1>{data.hero.title}</h1>
            <p className="hero-subtitle prominent-subtitle">{data.hero.subtitle}</p>
            <div className="cta-buttons">
              {data.hero.ctaButtons.map((button, index) => (
                <button 
                  key={index}
                  onClick={() => { gtag_report_conversion(); openPopup(button.type === 'primary' ? 'schedule_call' : 'curriculum'); }}
                  className={`button button-${button.type}`}
                >
                  {button.text}
                </button>
              ))}
            </div>
            <p className="stats-text">{data.hero.statsText}</p>
          </div>
          <div className="hero-image" style={{ flex: '0 0 340px', textAlign: 'right' }}>
            <img src="/images/man.avif" alt="Architect" style={{ maxWidth: '340px', width: '100%', height: 'auto', borderRadius: '18px', boxShadow: '0 4px 24px rgba(44,62,80,0.10)' }} />
          </div>
        </div>
      </section>

      <section className="benefits-section">
        <div className="container">
          <div className="benefits-grid">
            {data.benefits.items.map((item, index) => (
              <div key={index} className="benefit-card">
                <img src={item.icon} alt={item.title} />
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="pillars-section" style={{ background: '#f8f9fa', padding: '60px 0' }}>
        <div className="container">
          <div className="pillars-intro">
            <p style={{ textAlign: 'center', fontSize: '1.1rem', color: '#666', marginBottom: '1rem' }}>{data.pillars.intro.context}</p>
            <h2 style={{ textAlign: 'center', color: '#DA291C', marginBottom: '0.5rem' }}>The SPARKS Framework</h2>
            <p style={{ textAlign: 'center', fontSize: '1.05rem', color: '#333', marginBottom: '3rem' }} dangerouslySetInnerHTML={{ __html: data.pillars.intro.subtitle }}></p>
          </div>
          <div style={{ maxWidth: '900px', margin: '0 auto', position: 'relative' }}>
            {/* Vertical connecting line */}
            <div style={{ position: 'absolute', left: '40px', top: '80px', bottom: '80px', width: '3px', background: 'linear-gradient(to bottom, #DA291C, #ff6b6b)', zIndex: 0 }}></div>
            
            {data.pillars.items.map((pillar, index) => (
              <div 
                key={index} 
                className="pillar-step-item"
                data-index={index}
                style={{ 
                  display: 'flex', 
                  alignItems: 'flex-start', 
                  gap: '30px', 
                  marginBottom: index < data.pillars.items.length - 1 ? '50px' : '0', 
                  position: 'relative', 
                  zIndex: 1,
                  opacity: visibleSteps.includes(index) ? 1 : 0,
                  transform: visibleSteps.includes(index) ? 'translateX(0)' : 'translateX(-100px)',
                  transition: `opacity 0.6s ease-out ${index * 0.15}s, transform 0.6s ease-out ${index * 0.15}s`
                }}>
                <div style={{ flex: '0 0 80px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
                  <div style={{ width: '80px', height: '80px', borderRadius: '50%', background: '#fff', border: '4px solid #DA291C', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 12px rgba(218, 41, 28, 0.2)' }}>
                    <img src={pillar.icon} alt={pillar.title} style={{ width: '45px', height: '45px' }} />
                  </div>
                  <div style={{ background: '#DA291C', color: '#fff', borderRadius: '20px', padding: '4px 14px', fontSize: '0.9rem', fontWeight: '700' }}>Step {pillar.number}</div>
                </div>
                <div style={{ flex: 1, background: '#fff', borderRadius: '12px', padding: '28px', boxShadow: '0 3px 15px rgba(0,0,0,0.08)', border: '2px solid #f0f0f0', transition: 'transform 0.2s, box-shadow 0.2s' }} 
                     onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateX(8px)'; e.currentTarget.style.boxShadow = '0 5px 20px rgba(218, 41, 28, 0.15)'; }}
                     onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateX(0)'; e.currentTarget.style.boxShadow = '0 3px 15px rgba(0,0,0,0.08)'; }}>
                  <h3 style={{ fontSize: '1.4rem', fontWeight: '700', color: '#DA291C', marginBottom: '12px' }}>{pillar.title}</h3>
                  <div style={{ fontSize: '1.05rem', color: '#555', lineHeight: '1.6', margin: 0 }} dangerouslySetInnerHTML={{ __html: pillar.description }}></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Who Is This For Section */}
      <section className="who-is-this-for-section" style={{ background: '#fff', padding: '60px 0' }}>
        <div className="container">
          <h2 style={{ textAlign: 'center', color: '#DA291C', marginBottom: '1rem', fontSize: '2.2rem', fontWeight: 700 }}>Who Is This For?</h2>
          <p style={{ textAlign: 'center', fontSize: '1.15rem', color: '#333', marginBottom: '3rem', maxWidth: '800px', margin: '0 auto 3rem' }}>
            Designed for Engineers ready to influence <strong>Executive Leadership</strong>, guide <strong>Solution Builders</strong>, and partner with <strong>Operational Management</strong>
          </p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '32px', maxWidth: '1100px', margin: '0 auto' }}>
            <div 
              className="who-card-item"
              data-cardindex="0"
              style={{ 
                background: '#f8f9fa', 
                borderRadius: '16px', 
                padding: '36px 28px', 
                textAlign: 'center', 
                border: '2px solid #e8e8e8', 
                transition: 'transform 0.3s, box-shadow 0.3s',
                opacity: visibleWhoCards.includes(0) ? 1 : 0,
                transform: visibleWhoCards.includes(0) ? 'perspective(1000px) rotateY(0deg)' : 'perspective(1000px) rotateY(90deg)',
                transitionDelay: '0s',
                transitionDuration: '0.7s',
                transitionTimingFunction: 'ease-out'
              }}
              onMouseEnter={(e) => { if (visibleWhoCards.includes(0)) { e.currentTarget.style.transform = 'perspective(1000px) rotateY(0deg) translateY(-8px)'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(218, 41, 28, 0.15)'; } }}
              onMouseLeave={(e) => { if (visibleWhoCards.includes(0)) { e.currentTarget.style.transform = 'perspective(1000px) rotateY(0deg) translateY(0)'; e.currentTarget.style.boxShadow = 'none'; } }}>
              <div style={{ width: '80px', height: '80px', margin: '0 auto 20px', background: '#DA291C', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <img src="/images/icons/circles/architectural-communication.svg" alt="Executive Leadership" style={{ width: '45px', height: '45px', filter: 'brightness(0) invert(1)' }} />
              </div>
              <h3 style={{ fontSize: '1.3rem', fontWeight: 700, color: '#DA291C', marginBottom: '12px' }}>Influence Executive Leadership</h3>
              <p style={{ fontSize: '1rem', color: '#555', lineHeight: '1.6' }}>Shape strategic direction and technology roadmaps at the highest organizational levels</p>
            </div>
            <div 
              className="who-card-item"
              data-cardindex="1"
              style={{ 
                background: '#f8f9fa', 
                borderRadius: '16px', 
                padding: '36px 28px', 
                textAlign: 'center', 
                border: '2px solid #e8e8e8', 
                transition: 'transform 0.3s, box-shadow 0.3s',
                opacity: visibleWhoCards.includes(1) ? 1 : 0,
                transform: visibleWhoCards.includes(1) ? 'perspective(1000px) rotateY(0deg)' : 'perspective(1000px) rotateY(90deg)',
                transitionDelay: '0.15s',
                transitionDuration: '0.7s',
                transitionTimingFunction: 'ease-out'
              }}
              onMouseEnter={(e) => { if (visibleWhoCards.includes(1)) { e.currentTarget.style.transform = 'perspective(1000px) rotateY(0deg) translateY(-8px)'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(218, 41, 28, 0.15)'; } }}
              onMouseLeave={(e) => { if (visibleWhoCards.includes(1)) { e.currentTarget.style.transform = 'perspective(1000px) rotateY(0deg) translateY(0)'; e.currentTarget.style.boxShadow = 'none'; } }}>
              <div style={{ width: '80px', height: '80px', margin: '0 auto 20px', background: '#DA291C', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <img src="/images/icons/circles/solution-architect.svg" alt="Solution Builders" style={{ width: '45px', height: '45px', filter: 'brightness(0) invert(1)' }} />
              </div>
              <h3 style={{ fontSize: '1.3rem', fontWeight: 700, color: '#DA291C', marginBottom: '12px' }}>Guide Solution Builders</h3>
              <p style={{ fontSize: '1rem', color: '#555', lineHeight: '1.6' }}>Lead technical teams and developers in implementing scalable, maintainable solutions</p>
            </div>
            <div 
              className="who-card-item"
              data-cardindex="2"
              style={{ 
                background: '#f8f9fa', 
                borderRadius: '16px', 
                padding: '36px 28px', 
                textAlign: 'center', 
                border: '2px solid #e8e8e8', 
                transition: 'transform 0.3s, box-shadow 0.3s',
                opacity: visibleWhoCards.includes(2) ? 1 : 0,
                transform: visibleWhoCards.includes(2) ? 'perspective(1000px) rotateY(0deg)' : 'perspective(1000px) rotateY(90deg)',
                transitionDelay: '0.3s',
                transitionDuration: '0.7s',
                transitionTimingFunction: 'ease-out'
              }}
              onMouseEnter={(e) => { if (visibleWhoCards.includes(2)) { e.currentTarget.style.transform = 'perspective(1000px) rotateY(0deg) translateY(-8px)'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(218, 41, 28, 0.15)'; } }}
              onMouseLeave={(e) => { if (visibleWhoCards.includes(2)) { e.currentTarget.style.transform = 'perspective(1000px) rotateY(0deg) translateY(0)'; e.currentTarget.style.boxShadow = 'none'; } }}>
              <div style={{ width: '80px', height: '80px', margin: '0 auto 20px', background: '#DA291C', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <img src="/images/icons/circles/tactical-execution.svg" alt="Operational Management" style={{ width: '45px', height: '45px', filter: 'brightness(0) invert(1)' }} />
              </div>
              <h3 style={{ fontSize: '1.3rem', fontWeight: 700, color: '#DA291C', marginBottom: '12px' }}>Partner with Operations</h3>
              <p style={{ fontSize: '1rem', color: '#555', lineHeight: '1.6' }}>Collaborate with operational teams to ensure seamless execution and delivery</p>
            </div>
          </div>
        </div>
      </section>

      {/* Tools You Will Master Section */}
      <section className="tools-section" style={{ background: '#f8f9fa', padding: '60px 0' }}>
        <div className="container">
          <h2 style={{ textAlign: 'center', color: '#DA291C', marginBottom: '1rem', fontSize: '2.2rem', fontWeight: 700 }}>Tools You Will Master</h2>
          <p style={{ textAlign: 'center', fontSize: '1.1rem', color: '#666', marginBottom: '3rem', maxWidth: '700px', margin: '0 auto 3rem' }}>
            Practical frameworks and templates to guide your architecture journey
          </p>
          <div style={{ maxWidth: '900px', margin: '0 auto', display: 'flex', flexDirection: 'column', gap: '28px' }}>
            <div 
              className="tool-card-item"
              data-toolindex="0"
              style={{ 
                background: '#fff', 
                borderRadius: '14px', 
                padding: '32px', 
                boxShadow: '0 3px 15px rgba(0,0,0,0.08)', 
                border: '2px solid #e8e8e8', 
                display: 'flex', 
                alignItems: 'flex-start', 
                gap: '24px', 
                transition: 'transform 0.3s, box-shadow 0.3s',
                opacity: visibleToolCards.includes(0) ? 1 : 0,
                transform: visibleToolCards.includes(0) ? 'perspective(1000px) rotateX(0deg)' : 'perspective(1000px) rotateX(-90deg)',
                transitionDelay: '0s',
                transitionDuration: '0.7s',
                transitionTimingFunction: 'ease-out',
                marginLeft: '0',
                marginRight: 'auto'
              }}
              onMouseEnter={(e) => { if (visibleToolCards.includes(0)) { e.currentTarget.style.transform = 'perspective(1000px) rotateX(0deg) translateX(8px)'; e.currentTarget.style.boxShadow = '0 5px 20px rgba(218, 41, 28, 0.12)'; } }}
              onMouseLeave={(e) => { if (visibleToolCards.includes(0)) { e.currentTarget.style.transform = 'perspective(1000px) rotateX(0deg) translateX(0)'; e.currentTarget.style.boxShadow = '0 3px 15px rgba(0,0,0,0.08)'; } }}>
              <div style={{ flex: '0 0 70px', width: '70px', height: '70px', borderRadius: '50%', background: 'linear-gradient(135deg, #DA291C, #ff6b6b)', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 12px rgba(218, 41, 28, 0.3)' }}>
                <img src="/images/icons/document.svg" alt="Problem Statement Canvas" style={{ width: '38px', height: '38px', filter: 'brightness(0) invert(1)' }} />
              </div>
              <div style={{ flex: 1 }}>
                <h3 style={{ fontSize: '1.4rem', fontWeight: 700, color: '#DA291C', marginBottom: '10px' }}>The Problem Statement Canvas</h3>
                <p style={{ fontSize: '1.05rem', color: '#555', lineHeight: '1.7', margin: 0 }}>A framework to identify root causes and business impact.</p>
              </div>
            </div>
            <div 
              className="tool-card-item"
              data-toolindex="1"
              style={{ 
                background: '#fff', 
                borderRadius: '14px', 
                padding: '32px', 
                boxShadow: '0 3px 15px rgba(0,0,0,0.08)', 
                border: '2px solid #e8e8e8', 
                display: 'flex', 
                alignItems: 'flex-start', 
                gap: '24px', 
                flexDirection: 'row-reverse',
                transition: 'transform 0.3s, box-shadow 0.3s',
                opacity: visibleToolCards.includes(1) ? 1 : 0,
                transform: visibleToolCards.includes(1) ? 'perspective(1000px) rotateX(0deg)' : 'perspective(1000px) rotateX(-90deg)',
                transitionDelay: '0.15s',
                transitionDuration: '0.7s',
                transitionTimingFunction: 'ease-out',
                marginLeft: 'auto',
                marginRight: '0'
              }}
              onMouseEnter={(e) => { if (visibleToolCards.includes(1)) { e.currentTarget.style.transform = 'perspective(1000px) rotateX(0deg) translateX(-8px)'; e.currentTarget.style.boxShadow = '0 5px 20px rgba(218, 41, 28, 0.12)'; } }}
              onMouseLeave={(e) => { if (visibleToolCards.includes(1)) { e.currentTarget.style.transform = 'perspective(1000px) rotateX(0deg) translateX(0)'; e.currentTarget.style.boxShadow = '0 3px 15px rgba(0,0,0,0.08)'; } }}>
              <div style={{ flex: '0 0 70px', width: '70px', height: '70px', borderRadius: '50%', background: 'linear-gradient(135deg, #DA291C, #ff6b6b)', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 12px rgba(218, 41, 28, 0.3)' }}>
                <img src="/images/icons/build.svg" alt="Solution View Matrix" style={{ width: '38px', height: '38px', filter: 'brightness(0) invert(1)' }} />
              </div>
              <div style={{ flex: 1, textAlign: 'right' }}>
                <h3 style={{ fontSize: '1.4rem', fontWeight: 700, color: '#DA291C', marginBottom: '10px' }}>The Solution View Matrix</h3>
                <p style={{ fontSize: '1.05rem', color: '#555', lineHeight: '1.7', margin: 0 }}>Templates for Business, Technical, Functional, and Operational views.</p>
              </div>
            </div>
            <div 
              className="tool-card-item"
              data-toolindex="2"
              style={{ 
                background: '#fff', 
                borderRadius: '14px', 
                padding: '32px', 
                boxShadow: '0 3px 15px rgba(0,0,0,0.08)', 
                border: '2px solid #e8e8e8', 
                display: 'flex', 
                alignItems: 'flex-start', 
                gap: '24px', 
                transition: 'transform 0.3s, box-shadow 0.3s',
                opacity: visibleToolCards.includes(2) ? 1 : 0,
                transform: visibleToolCards.includes(2) ? 'perspective(1000px) rotateX(0deg)' : 'perspective(1000px) rotateX(-90deg)',
                transitionDelay: '0.3s',
                transitionDuration: '0.7s',
                transitionTimingFunction: 'ease-out',
                marginLeft: '0',
                marginRight: 'auto'
              }}
              onMouseEnter={(e) => { if (visibleToolCards.includes(2)) { e.currentTarget.style.transform = 'perspective(1000px) rotateX(0deg) translateX(8px)'; e.currentTarget.style.boxShadow = '0 5px 20px rgba(218, 41, 28, 0.12)'; } }}
              onMouseLeave={(e) => { if (visibleToolCards.includes(2)) { e.currentTarget.style.transform = 'perspective(1000px) rotateX(0deg) translateX(0)'; e.currentTarget.style.boxShadow = '0 3px 15px rgba(0,0,0,0.08)'; } }}>
              <div style={{ flex: '0 0 70px', width: '70px', height: '70px', borderRadius: '50%', background: 'linear-gradient(135deg, #DA291C, #ff6b6b)', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 12px rgba(218, 41, 28, 0.3)' }}>
                <img src="/images/icons/copilot/certificate.svg" alt="Architect's Storyboard" style={{ width: '38px', height: '38px', filter: 'brightness(0) invert(1)' }} />
              </div>
              <div style={{ flex: 1 }}>
                <h3 style={{ fontSize: '1.4rem', fontWeight: 700, color: '#DA291C', marginBottom: '10px' }}>The Architect's Storyboard</h3>
                <p style={{ fontSize: '1.05rem', color: '#555', lineHeight: '1.7', margin: 0 }}>A guide to structuring your "Keynote" presentation.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Module Roadmap Section */}
      <section className="itinerary-section" style={{ background: '#fff', padding: '48px 0' }}>
        <div className="container">
          <h2 style={{ textAlign: 'center', marginBottom: '2.5rem', color: '#DA291C', fontWeight: 700 }}>SPARKS Framework for Aspiring Architects</h2>
          <div className="itinerary-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '32px', maxWidth: '1200px', margin: '0 auto' }}>
            {itinerary.map((month, idx) => {
              const row = Math.floor(idx / 2);
              const col = idx % 2;
              const isRed = (row + col) % 2 === 1;
              return (
                <div
                  key={month.month}
                  className="itinerary-card module-card-item"
                  data-moduleindex={idx}
                  style={{
                    background: isRed ? '#DA291C' : '#fff',
                    color: isRed ? '#fff' : '#222',
                    borderRadius: '14px',
                    boxShadow: '0 2px 12px rgba(44,62,80,0.08)',
                    padding: '28px 22px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px',
                    opacity: visibleModules.includes(idx) ? 1 : 0,
                    transform: visibleModules.includes(idx) ? 'scale(1)' : 'scale(0.9)',
                    transition: `opacity 0.6s ease-out ${idx * 0.15}s, transform 0.6s ease-out ${idx * 0.15}s`
                  }}
                >
                  <div style={{ fontWeight: 700, color: isRed ? '#fff' : '#DA291C', fontSize: '1.1rem', marginBottom: '8px' }}>{month.month}</div>
                  <h3 style={{  fontWeight: 700, fontSize: '1.2rem', marginBottom: '8px', color: isRed ? '#fff' : '#222' }}>{month.title}</h3>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', justifyContent: 'center', marginBottom: '4px' }}>
                    <img src="/images/icons/learn.svg" alt="Learn" style={{ width: '33px', height: '33px', filter: isRed ? 'brightness(0) invert(1)' : 'none', display: 'block' }} />
            
                  </div>
                  <ul style={{ margin: '8px 0 0 0', padding: 0, listStyle: 'none', color: isRed ? '#fff' : '#222', fontSize: '1rem' }}>
                    {month.learn.map((item, i) => (
                      <li key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                        <span style={{ color: '#DA291C', fontWeight: 700, fontSize: '1.1em', display: 'inline-block' }}>&#8594;</span>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', justifyContent: 'center', marginTop: '14px', marginBottom: '4px' }}>
                    <img src="/images/icons/activities.svg" alt="Activities" style={{ width: '33px', height: '33px', filter: isRed ? 'brightness(0) invert(1)' : 'none', display: 'block' }} />
                 
                  </div>
                  <ul style={{ margin: '8px 0 0 0', padding: 0, listStyle: 'none', color: isRed ? '#fff' : '#555', fontSize: '0.98rem' }}>
                    {month.activities.map((act, i) => (
                      <li key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                        <span style={{ color: '#DA291C', fontWeight: 700, fontSize: '1.1em', display: 'inline-block' }}>&#8594;</span>
                        <span>{act}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Program Inclusions Section */}
      <section className="program-inclusions-section" style={{ background: '#f8f9fa', padding: '60px 0' }}>
        <div className="container">
          <h2 style={{ textAlign: 'center', color: '#DA291C', marginBottom: '1rem', fontSize: '2.2rem', fontWeight: 700 }}>Program Inclusions</h2>
          <p style={{ textAlign: 'center', fontSize: '1.15rem', color: '#333', marginBottom: '0.5rem', maxWidth: '800px', margin: '0 auto 0.5rem' }}>
            <strong>Premium Mentorship & Career Growth</strong>
          </p>
          <p style={{ textAlign: 'center', fontSize: '1.05rem', color: '#666', marginBottom: '3rem', maxWidth: '700px', margin: '0 auto 3rem' }}>
            Personal interaction, networking, and long-term support.
          </p>
          <div style={{ maxWidth: '1000px', margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '28px' }}>
            <div style={{ background: '#fff', borderRadius: '14px', padding: '32px', boxShadow: '0 3px 15px rgba(0,0,0,0.08)', border: '2px solid #e8e8e8', transition: 'transform 0.3s, box-shadow 0.3s' }}
                 onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 5px 20px rgba(218, 41, 28, 0.12)'; }}
                 onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 3px 15px rgba(0,0,0,0.08)'; }}>
              <div style={{ fontSize: '2rem', marginBottom: '12px' }}>🤝</div>
              <h3 style={{ fontSize: '1.3rem', fontWeight: 700, color: '#DA291C', marginBottom: '8px' }}>1-on-1 Strategy Session</h3>
              <p style={{ fontSize: '1rem', fontWeight: 600, color: '#333', marginBottom: '12px' }}>Personalized Implementation Roadmapping.</p>
              <p style={{ fontSize: '0.98rem', color: '#555', lineHeight: '1.7', margin: 0 }}>
                A private 45-minute call with the mentor (scheduled in Month 2) to review your specific work challenges and apply the SPARKS framework to your career path.
              </p>
            </div>
            <div style={{ background: '#fff', borderRadius: '14px', padding: '32px', boxShadow: '0 3px 15px rgba(0,0,0,0.08)', border: '2px solid #e8e8e8', transition: 'transform 0.3s, box-shadow 0.3s' }}
                 onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 5px 20px rgba(218, 41, 28, 0.12)'; }}
                 onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 3px 15px rgba(0,0,0,0.08)'; }}>
              <div style={{ fontSize: '2rem', marginBottom: '12px' }}>📂</div>
              <h3 style={{ fontSize: '1.3rem', fontWeight: 700, color: '#DA291C', marginBottom: '8px' }}>"Architect Portfolio" Review</h3>
              <p style={{ fontSize: '1rem', fontWeight: 600, color: '#333', marginBottom: '12px' }}>Prove Your Expertise.</p>
              <p style={{ fontSize: '0.98rem', color: '#555', lineHeight: '1.7', margin: 0 }}>
                Most engineers only have a resume. We guide you on building a "Case Study Portfolio" that visualizes your architectural thinking—the #1 asset for landing high-level roles.
              </p>
            </div>
            <div style={{ background: '#fff', borderRadius: '14px', padding: '32px', boxShadow: '0 3px 15px rgba(0,0,0,0.08)', border: '2px solid #e8e8e8', transition: 'transform 0.3s, box-shadow 0.3s' }}
                 onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 5px 20px rgba(218, 41, 28, 0.12)'; }}
                 onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 3px 15px rgba(0,0,0,0.08)'; }}>
              <div style={{ fontSize: '2rem', marginBottom: '12px' }}>💬</div>
              <h3 style={{ fontSize: '1.3rem', fontWeight: 700, color: '#DA291C', marginBottom: '8px' }}>The "Inner Circle" Discord</h3>
              <p style={{ fontSize: '1rem', fontWeight: 600, color: '#333', marginBottom: '12px' }}>Network with Leaders.</p>
              <p style={{ fontSize: '0.98rem', color: '#555', lineHeight: '1.7', margin: 0 }}>
                Join a private, invite-only community of aspiring and established tech leaders. Share job opportunities, get rapid feedback on designs, and grow your professional network.
              </p>
            </div>
            <div style={{ background: '#fff', borderRadius: '14px', padding: '32px', boxShadow: '0 3px 15px rgba(0,0,0,0.08)', border: '2px solid #e8e8e8', transition: 'transform 0.3s, box-shadow 0.3s' }}
                 onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 5px 20px rgba(218, 41, 28, 0.12)'; }}
                 onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 3px 15px rgba(0,0,0,0.08)'; }}>
              <div style={{ fontSize: '2rem', marginBottom: '12px' }}>🔄</div>
              <h3 style={{ fontSize: '1.3rem', fontWeight: 700, color: '#DA291C', marginBottom: '8px' }}>The Feedback Loop</h3>
              <p style={{ fontSize: '1rem', fontWeight: 600, color: '#333', marginBottom: '12px' }}>Continuous Support.</p>
              <p style={{ fontSize: '0.98rem', color: '#555', lineHeight: '1.7', margin: 0 }}>
                Access to monthly Group Q&A sessions to unblock challenges as you execute. We don't just teach you and leave; we stay to help you apply it.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* The Architect's Toolkit & Accelerators Section */}
      <section className="toolkit-accelerators-section" style={{ background: '#fff', padding: '60px 0' }}>
        <div className="container">
          <h2 style={{ textAlign: 'center', color: '#DA291C', marginBottom: '1rem', fontSize: '2.2rem', fontWeight: 700 }}>The Architect's Toolkit & Accelerators</h2>
          <p style={{ textAlign: 'center', fontSize: '1.05rem', color: '#666', marginBottom: '3rem', maxWidth: '700px', margin: '0 auto 3rem' }}>
            Downloadable assets, templates, and practical simulations.
          </p>
          <div style={{ maxWidth: '1000px', margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '28px' }}>
            <div style={{ background: '#f8f9fa', borderRadius: '14px', padding: '32px', boxShadow: '0 3px 15px rgba(0,0,0,0.08)', border: '2px solid #e8e8e8', transition: 'transform 0.3s, box-shadow 0.3s' }}
                 onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 5px 20px rgba(218, 41, 28, 0.12)'; }}
                 onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 3px 15px rgba(0,0,0,0.08)'; }}>
              <div style={{ fontSize: '2rem', marginBottom: '12px' }}>🧰</div>
              <h3 style={{ fontSize: '1.3rem', fontWeight: 700, color: '#DA291C', marginBottom: '8px' }}>The Architect's OS</h3>
              <p style={{ fontSize: '1rem', fontWeight: 600, color: '#333', marginBottom: '12px' }}>Ready-to-Use Asset Pack.</p>
              <p style={{ fontSize: '0.98rem', color: '#555', lineHeight: '1.7', margin: 0 }}>
                Stop starting from scratch. Get the downloadable SPARKS Strategy Deck, ADR (Decision Record) Logs, and NFR Checklists to use in your job immediately.
              </p>
            </div>
            <div style={{ background: '#f8f9fa', borderRadius: '14px', padding: '32px', boxShadow: '0 3px 15px rgba(0,0,0,0.08)', border: '2px solid #e8e8e8', transition: 'transform 0.3s, box-shadow 0.3s' }}
                 onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 5px 20px rgba(218, 41, 28, 0.12)'; }}
                 onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 3px 15px rgba(0,0,0,0.08)'; }}>
              <div style={{ fontSize: '2rem', marginBottom: '12px' }}>🤖</div>
              <h3 style={{ fontSize: '1.3rem', fontWeight: 700, color: '#DA291C', marginBottom: '8px' }}>AI for Architects (Bonus)</h3>
              <p style={{ fontSize: '1rem', fontWeight: 600, color: '#333', marginBottom: '12px' }}>Future-Proof Your Workflow.</p>
              <p style={{ fontSize: '0.98rem', color: '#555', lineHeight: '1.7', margin: 0 }}>
                An exclusive masterclass on using GenAI tools (ChatGPT/Copilot) to draft system diagrams, critique patterns, and accelerate technical documentation.
              </p>
            </div>
            <div style={{ background: '#f8f9fa', borderRadius: '14px', padding: '32px', boxShadow: '0 3px 15px rgba(0,0,0,0.08)', border: '2px solid #e8e8e8', transition: 'transform 0.3s, box-shadow 0.3s' }}
                 onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 5px 20px rgba(218, 41, 28, 0.12)'; }}
                 onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 3px 15px rgba(0,0,0,0.08)'; }}>
              <div style={{ fontSize: '2rem', marginBottom: '12px' }}>🎙️</div>
              <h3 style={{ fontSize: '1.3rem', fontWeight: 700, color: '#DA291C', marginBottom: '8px' }}>The "Mock Boardroom"</h3>
              <p style={{ fontSize: '1rem', fontWeight: 600, color: '#333', marginBottom: '12px' }}>Simulation & Feedback.</p>
              <p style={{ fontSize: '0.98rem', color: '#555', lineHeight: '1.7', margin: 0 }}>
                Practice your "Keynote" pitch in a safe environment. Receive real-time critique on your storytelling and stakeholder management skills before you face real executives.
              </p>
            </div>
            <div style={{ background: '#f8f9fa', borderRadius: '14px', padding: '32px', boxShadow: '0 3px 15px rgba(0,0,0,0.08)', border: '2px solid #e8e8e8', transition: 'transform 0.3s, box-shadow 0.3s' }}
                 onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 5px 20px rgba(218, 41, 28, 0.12)'; }}
                 onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 3px 15px rgba(0,0,0,0.08)'; }}>
              <div style={{ fontSize: '2rem', marginBottom: '12px' }}>📼</div>
              <h3 style={{ fontSize: '1.3rem', fontWeight: 700, color: '#DA291C', marginBottom: '8px' }}>Extended Access</h3>
              <p style={{ fontSize: '1rem', fontWeight: 600, color: '#333', marginBottom: '12px' }}>Review at Your Pace.</p>
              <p style={{ fontSize: '0.98rem', color: '#555', lineHeight: '1.7', margin: 0 }}>
                Get 4 months of extended access to all workshop recordings and materials, ensuring you can revisit complex concepts whenever you need a refresher.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="pricing-section" style={{ background: '#f8f9fa', padding: '60px 0' }}>
        <div className="container">
          <div style={{ maxWidth: '800px', margin: '0 auto', background: '#fff', borderRadius: '16px', padding: '48px', boxShadow: '0 4px 24px rgba(0,0,0,0.1)', border: '3px solid #DA291C' }}>
            <h2 style={{ textAlign: 'center', color: '#DA291C', marginBottom: '0.5rem', fontSize: '2rem', fontWeight: 700 }}>Aspiring Architect Accelerator (Live Cohort)</h2>
            <p style={{ textAlign: 'center', fontSize: '1.05rem', color: '#666', marginBottom: '2rem' }}>
              Batch Starts Soon • Limited to 30 Seats
            </p>
            
            <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
              <div style={{ display: 'inline-block' }}>
                <span style={{ fontSize: '1.5rem', color: '#999', textDecoration: 'line-through', marginRight: '12px' }}>{pricing.original}</span>
                <span style={{ fontSize: '2.5rem', color: '#DA291C', fontWeight: 700 }}>{pricing.current}</span>
              </div>
              <p style={{ fontSize: '0.95rem', color: '#DA291C', fontWeight: 600, marginTop: '8px' }}>(Early Bird Pricing - Ends Soon)</p>
            </div>

            <div style={{ marginBottom: '2rem' }}>
              <h3 style={{ fontSize: '1.4rem', fontWeight: 700, color: '#333', marginBottom: '16px', borderBottom: '2px solid #DA291C', paddingBottom: '8px' }}>What's Included (The Core):</h3>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                <li style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', marginBottom: '12px', fontSize: '1.05rem', color: '#333' }}>
                  <span style={{ color: '#DA291C', fontSize: '1.2rem', fontWeight: 700 }}>✅</span>
                  <span>4 Live Intensive Workshops (Saturdays, 1.5 - 2 Hours)</span>
                </li>
                <li style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', marginBottom: '12px', fontSize: '1.05rem', color: '#333' }}>
                  <span style={{ color: '#DA291C', fontSize: '1.2rem', fontWeight: 700 }}>✅</span>
                  <span>Month 2 Implementation Mentorship (1-on-1 Call)</span>
                </li>
                <li style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', marginBottom: '12px', fontSize: '1.05rem', color: '#333' }}>
                  <span style={{ color: '#DA291C', fontSize: '1.2rem', fontWeight: 700 }}>✅</span>
                  <span>"The Architect's OS" Asset Pack (Templates & Checklists)</span>
                </li>
                <li style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', marginBottom: '12px', fontSize: '1.05rem', color: '#333' }}>
                  <span style={{ color: '#DA291C', fontSize: '1.2rem', fontWeight: 700 }}>✅</span>
                  <span>Certification of Completion</span>
                </li>
              </ul>
            </div>

            <div style={{ marginBottom: '2rem', background: '#fff5f3', padding: '24px', borderRadius: '12px', border: '2px dashed #DA291C' }}>
              <h3 style={{ fontSize: '1.4rem', fontWeight: 700, color: '#DA291C', marginBottom: '16px' }}>Exclusive Bonuses (Free for this Cohort):</h3>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                <li style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', marginBottom: '12px', fontSize: '1.05rem', color: '#333' }}>
                  <span style={{ fontSize: '1.2rem' }}>🎁</span>
                  <span><strong>Bonus:</strong> "AI for Architects" Masterclass (Value: ₹5,000)</span>
                </li>
                <li style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', marginBottom: '12px', fontSize: '1.05rem', color: '#333' }}>
                  <span style={{ fontSize: '1.2rem' }}>🎁</span>
                  <span><strong>Bonus:</strong> "Mock Boardroom" Simulation Access</span>
                </li>
                <li style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', marginBottom: '12px', fontSize: '1.05rem', color: '#333' }}>
                  <span style={{ fontSize: '1.2rem' }}>🎁</span>
                  <span><strong>Bonus:</strong> Private "Inner Circle" Discord Access</span>
                </li>
                <li style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', marginBottom: '12px', fontSize: '1.05rem', color: '#333' }}>
                  <span style={{ fontSize: '1.2rem' }}>🎁</span>
                  <span><strong>Bonus:</strong> Architect Portfolio Review Guide</span>
                </li>
              </ul>
            </div>

            <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
              <button 
                onClick={() => { gtag_report_conversion(); openPopup('schedule_call'); }}
                style={{ 
                  background: '#DA291C', 
                  color: '#fff', 
                  border: 'none', 
                  padding: '18px 48px', 
                  borderRadius: '8px', 
                  fontSize: '1.2rem', 
                  fontWeight: 700, 
                  cursor: 'pointer', 
                  transition: 'transform 0.2s, box-shadow 0.2s',
                  boxShadow: '0 4px 12px rgba(218, 41, 28, 0.3)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 6px 20px rgba(218, 41, 28, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(218, 41, 28, 0.3)';
                }}
              >
                Secure My Spot for ₹24,999
              </button>
              <p style={{ fontSize: '0.95rem', color: '#555', marginTop: '12px', fontWeight: 600 }}>
                100% Money-Back Guarantee (7 Days)
              </p>
            </div>

            <div style={{ background: '#f8f9fa', padding: '20px', borderRadius: '8px', marginBottom: '1rem' }}>
              <p style={{ fontSize: '0.95rem', color: '#555', textAlign: 'center', margin: 0 }}>
                Need a corporate invoice for reimbursement? We provide GST-compliant invoices instantly.
              </p>
            </div>

            <div style={{ background: 'linear-gradient(135deg, #DA291C, #ff6b6b)', color: '#fff', padding: '28px', borderRadius: '12px', textAlign: 'center', boxShadow: '0 4px 16px rgba(218, 41, 28, 0.3)' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', marginBottom: '12px' }}>
                <span style={{ fontSize: '2rem' }}>💡</span>
                <h3 style={{ fontSize: '1.5rem', fontWeight: 700, margin: 0 }}>Did You Know?</h3>
              </div>
              <p style={{ fontSize: '1.05rem', fontWeight: 600, margin: 0, lineHeight: '1.6' }}>
                The average salary gap between a Senior Dev and a Solution Architect in India is ₹12 Lakhs/year. This program costs ~2% of your potential first-year raise.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="career-path-section">
        <div className="container">
          <div className="career-path-title">
            <h2>{data.careerPath.title}</h2>
          </div>
          <div className="career-progression-aligned">
            {[...data.careerPath.levels].reverse().map((level) => (
              <div key={level.level} className="career-step-row">
                <div className={`progression-block block-${level.level}`}>{level.level}</div>
                <div className="career-level">
                  <img src={level.icon} alt={level.title} />
                  <div className="level-content">
                    <h3>{level.title}</h3>
                    <p>{level.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="mentor-section">
        <div className="container">
          <div className="section-header-mentor">
            <h2>Meet Your <span className="highlight">Expert Mentor</span></h2>
            <p className="section-subtitle">Learn from an industry leader with decades of hands-on experience</p>
          </div>
          <div className="mentor-card mentor-infographic">
            <div className="mentor-left">
              <div className="mentor-image-wrapper">
                <div className="mentor-image-circle">
                  <img src={data.mentor.image} alt={data.mentor.name} />
                  <div className="mentor-badge">
                    <span>🏆</span>
                    <span className="badge-text">Expert</span>
                  </div>
                </div>
              </div>
              <div className="mentor-profile-info">
                <h3 className="mentor-name">{data.mentor.name}</h3>
                <p className="mentor-role">{data.mentor.role}</p>
                <div className="social-links">
                  <a href={data.mentor.socialLinks.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                    <img src="/images/icons/linkedin.svg" alt="LinkedIn" />
                  </a>
                  <a href={data.mentor.socialLinks.youtube} target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                    <img src="/images/icons/youtube.svg" alt="YouTube" />
                  </a>
                </div>
              </div>
            </div>
            <div className="mentor-content">
              <div className="mentor-infostats">
                <div className="mentor-stat">
                  <div className="mentor-stat-icon-wrapper">
                    <img src="/images/icons/experience.svg" alt="Experience" className="mentor-stat-icon" />
                  </div>
                  <div>
                    <div className="mentor-stat-value">20+</div>
                    <div className="mentor-stat-label">Years Experience</div>
                  </div>
                </div>
                <div className="mentor-stat">
                  <div className="mentor-stat-icon-wrapper">
                    <img src="/images/icons/certification.svg" alt="Certifications" className="mentor-stat-icon" />
                  </div>
                  <div>
                    <div className="mentor-stat-value">12</div>
                    <div className="mentor-stat-label">Certifications</div>
                  </div>
                </div>
                <div className="mentor-stat">
                  <div className="mentor-stat-icon-wrapper">
                    <img src="/images/icons/sessions.svg" alt="Sessions" className="mentor-stat-icon" />
                  </div>
                  <div>
                    <div className="mentor-stat-value">150+</div>
                    <div className="mentor-stat-label">Sessions Led</div>
                  </div>
                </div>
                <div className="mentor-stat">
                  <div className="mentor-stat-icon-wrapper">
                    <img src="/images/icons/students.svg" alt="Students" className="mentor-stat-icon" />
                  </div>
                  <div>
                    <div className="mentor-stat-value">500+</div>
                    <div className="mentor-stat-label">Students Taught</div>
                  </div>
                </div>
              </div>
              <div className="mentor-description">
                {data.mentor.description.map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
              </div>
              <div className="mentor-cta">
                {data.mentor.ctaButtons.map((button, index) => (
                  <button 
                    key={index}
                    onClick={() => { gtag_report_conversion(); openPopup('mentor_connect'); }}
                    className={`button button-${button.type}`}
                  >
                    <span className="button-icon">💬</span>
                    {button.text}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="testimonials-section">
        <div className="container">
          <div className="testimonials-header">
            <h2>{data.testimonials.title}</h2>
          </div>
          <div className="testimonials-grid">
              {testimonials.map((testimonial, index) => (
                <div key={index} className="testimonial-card">
                  <div className="testimonial-rating">
                    {'★'.repeat(testimonial.rating || 5)}
                  </div>
                  <p className="testimonial-quote">{testimonial.quote}</p>
                  <div className="testimonial-author">
                    <div className="author-info">
                      <h4>{testimonial.author?.name || testimonial.name || 'Anonymous'}</h4>
                      <p>{testimonial.author?.role || testimonial.role || ''}</p>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </section>

      <section className="cta-final">
        <div className="container">
          <h2>{data.ctaFinal.title}</h2>
          <p>{data.ctaFinal.subtitle}</p>
          <div className="cta-buttons">
            {data.ctaFinal.buttons.map((button, index) => (
              <button 
                key={index}
                onClick={() => { gtag_report_conversion(); openPopup(button.type === 'primary' ? 'schedule_call' : 'curriculum'); }}
                className={`cta-button cta-button-${button.type}`}
              >
                {button.text}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Ask Chai Chatbot (Architect Program) */}
      <div
        style={{
          position: 'fixed',
          bottom: showTopBarForm && isMobileOrTablet ? '110px' : '28px',
          left: '24px',
          zIndex: 1250,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start'
        }}
      >
        {!showChaiChat && (
          <button
            onClick={() => setShowChaiChat(true)}
            style={{
              background: 'linear-gradient(135deg, #DA291C 0%, #b81f14 100%)',
              color: '#fff',
              border: 'none',
              borderRadius: '48px',
              padding: '14px 18px',
              fontSize: '0.98rem',
              fontWeight: 700,
              cursor: 'pointer',
              boxShadow: '0 6px 22px rgba(218, 41, 28, 0.35)',
              display: 'flex',
              alignItems: 'center',
              gap: '10px'
            }}
            aria-label="Open Ask Chai chatbot for Aspiring Architect Program"
          >
            <span style={{ fontSize: '1.2rem' }}>☕</span>
            Ask Chai about Architect
          </button>
        )}

        {showChaiChat && (
          <div
            style={{
              width: '360px',
              height: '520px',
              background: '#fff',
              borderRadius: '16px',
              boxShadow: '0 10px 32px rgba(0, 0, 0, 0.18)',
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden'
            }}
          >
            <div
              style={{
                background: 'linear-gradient(135deg, #DA291C 0%, #b81f14 100%)',
                color: '#fff',
                padding: '16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <span style={{ fontSize: '1.4rem' }}>☕</span>
                <div>
                  <h3 style={{ margin: 0, fontSize: '1.05rem', fontWeight: 700 }}>Ask Chai</h3>
                  <p style={{ margin: 0, fontSize: '0.85rem', opacity: 0.9 }}>Architect Program Concierge</p>
                </div>
              </div>
              <button
                onClick={() => setShowChaiChat(false)}
                style={{
                  background: 'rgba(255,255,255,0.18)',
                  border: 'none',
                  color: '#fff',
                  width: '32px',
                  height: '32px',
                  borderRadius: '50%',
                  cursor: 'pointer',
                  fontSize: '1.2rem'
                }}
                aria-label="Close Ask Chai chatbot"
              >
                ×
              </button>
            </div>

            <div style={{ padding: '10px 14px', display: 'flex', flexWrap: 'wrap', gap: '8px', background: '#fff' }}>
              {architectChatPrompts.map((prompt) => (
                <button
                  key={prompt.value}
                  onClick={() => handleChaiQuickPrompt(prompt.value)}
                  style={{
                    border: '1px solid #DA291C',
                    background: '#fff',
                    color: '#DA291C',
                    borderRadius: '20px',
                    padding: '6px 10px',
                    fontSize: '0.85rem',
                    cursor: 'pointer'
                  }}
                >
                  {prompt.label}
                </button>
              ))}
            </div>

            <div
              style={{
                flex: 1,
                padding: '14px',
                background: '#f8f9fa',
                overflowY: 'auto',
                display: 'flex',
                flexDirection: 'column',
                gap: '10px'
              }}
            >
              {chaiMessages.map((message, index) => (
                <div
                  key={`${message.timestamp}-${index}`}
                  style={{
                    display: 'flex',
                    justifyContent: message.type === 'user' ? 'flex-end' : 'flex-start'
                  }}
                >
                  <div
                    style={{
                      maxWidth: '78%',
                      padding: '10px 12px',
                      borderRadius: message.type === 'user' ? '14px 14px 4px 14px' : '14px 14px 14px 4px',
                      background: message.type === 'user' ? '#DA291C' : '#fff',
                      color: message.type === 'user' ? '#fff' : '#1f2933',
                      fontSize: '0.95rem',
                      lineHeight: 1.5,
                      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                      whiteSpace: 'pre-line'
                    }}
                  >
                    {message.text}
                  </div>
                </div>
              ))}
            </div>

            <form onSubmit={handleChaiSubmit} style={{ padding: '12px', borderTop: '1px solid #ececec', background: '#fff', display: 'flex', gap: '8px' }}>
              <input
                type="text"
                value={chaiInput}
                onChange={(e) => setChaiInput(e.target.value)}
                placeholder="Ask about the cohort..."
                style={{
                  flex: 1,
                  padding: '10px 12px',
                  borderRadius: '12px',
                  border: '1px solid #ddd',
                  fontSize: '0.95rem'
                }}
              />
              <button
                type="submit"
                style={{
                  background: '#DA291C',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '12px',
                  padding: '10px 14px',
                  fontWeight: 700,
                  cursor: 'pointer'
                }}
              >
                Send
              </button>
            </form>
          </div>
        )}
      </div>

      <PopupForm 
        isOpen={isPopupOpen} 
        onClose={closePopup} 
        formType={formType}
        onSubmit={async (formData) => {
          try {
            const response = await fetch(API_ENDPOINTS.LEADS_SUBMIT, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                ...formData,
                source: 'architect_program_page',
                interestedIn: (() => {
                  switch(formType) {
                    case 'schedule_call':
                      return 'architect_consultation';
                    case 'curriculum':
                      return 'architect_program';
                    case 'mentor_connect':
                      return 'mentorship';
                    default:
                      return 'architect_program';
                  }
                })()
              })
            });

            if (!response.ok) {
              throw new Error('Failed to submit form');
            }
            
            closePopup();
            showConfirmation(formType);
          } catch (error) {
            console.error('Error submitting form:', error);
            alert('Failed to submit form. Please try again.');
          }
        }}
      />

      {/* Confirmation Modal */}
      {confirmationModal.isOpen && (
        <div className="confirmation-modal">
          <div className="confirmation-content">
            <button className="close-button" onClick={closeConfirmation}>&times;</button>
            <h3>{confirmationModal.title}</h3>
            <p>{confirmationModal.message}</p>
          </div>
        </div>
      )}
    </div>
  );
}

export default ArchitectProgram;

function gtag_report_conversion(url) {
  if (window.gtag) {
    window.gtag('event', 'conversion', {
      send_to: 'AW-16782075468',
      event_callback: function () {
        if (url) {
          window.location = url;
        }
      }
    });
    return false;
  }
  return true;
}